import React, {useEffect, useState} from "react";
import Box, {Item,} from 'devextreme-react/box';
import {useCountertops} from "../../contexts/countertopsContext";
import {NumberBox} from "devextreme-react/number-box";

export function ShapesTotalControl() {
    const data = useCountertops();
    const [totals, setTotals] = useState([] as { name: string, total: number }[])

    useEffect(() => {
        let result = [] as { name: string, total: number }[];
        for (let i = 0; i < data.shapes.length; i++) {
            if (data.shapes[i].prodQteGrpID !== null && data.shapes[i].productID !== null) {
                let name = data.shapes[i].materialName + ' - ' + data.shapes[i].colorName;
                let item = result.find(x => x.name === name);
                let total = data.shapes[i].total ?? 0;
                total += data.shapes[i].backsplashes.reduce((acc, x) => acc + (x.total ?? 0), 0);
                if (item === undefined) {
                    result.push({name: name, total: total});
                } else {
                    item.total += total;
                }
            }
        }

        setTotals(result);
    }, [data.shapes])

    return (
        <>
            {totals.map((item) =>
                <Box
                    direction="row"
                    width="100%"
                    key={item.name}
                    style={{marginBottom: '10px'}}>
                    <Item ratio={6}>
                    </Item>
                    <Item ratio={4}>
                        <Box crossAlign='center'>
                            <Item baseSize={198}>
                                <label style={{textAlign: 'right'}}>
                                    {item.name}&nbsp;&nbsp;&nbsp;&nbsp;Total:&nbsp;
                                </label>
                            </Item>
                            <Item baseSize={70}>
                                <NumberBox
                                    stylingMode='outlined'
                                    readOnly={true}
                                    value={item.total}
                                    inputAttr={{"style": "text-align:center"}}
                                    className={"ee-read-only-text-color"}
                                />
                            </Item>
                            <Item baseSize='auto'>
                                &nbsp;sq. ft.
                            </Item>
                        </Box>
                    </Item>
                </Box>
            )}
        </>
    );
}
